
<!-- 
<div class="liveContainer">
  <div class="container-fluid" style="background: #0D0D0D;"> -->
    <!-- <div  class="cursor-pointer " style="z-index: 999;position: absolute;">
      <div class="back">
        <i class="fas fa-arrow-alt-left" (click)="backToInfo()"><span class="fs-16 fw-500"> {{'COMMON.BACK' |translate}} </span> </i>
      </div>
    </div> -->
    <div class="mx-auto player-contain series-contain" *ngIf="stream_Url" >
      <video id="example-videoplay" class="video-js player-video " controls autoplay  preload="none" 
        data-setup="{}"  controlslist="nodownload noplaybackrate">
        <source [src]="stream_Url" type="video/mp4" />
        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to a
          web browser that
          <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
        </p>
      </video>
    </div>
  <!-- </div>
</div> -->

<div class="custom-modal" *ngIf="showModal">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
      <!-- <button type="button" class="close" (click)="closeModal()">
        <span>&times;</span>
      </button> -->
    </div>
    <div class="modal-body">
      <!-- Your custom error message or content here -->
      <p class="text-dark">An error occurred during playing video.</p>
    </div>
    <div class="close">
      <button class="btn btn-primary" (click)="closePlayNext()">Close & Play Next</button>
    </div>
  </div>
</div>
